import { render, staticRenderFns } from "./ValetButton.vue?vue&type=template&id=611a8d52&scoped=true&"
import script from "./ValetButton.vue?vue&type=script&lang=js&"
export * from "./ValetButton.vue?vue&type=script&lang=js&"
import style0 from "./ValetButton.vue?vue&type=style&index=0&id=611a8d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611a8d52",
  null
  
)

export default component.exports